import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export function fadeImageDarkness() {
  gsap.registerPlugin(ScrollTrigger, SplitText);
  const animationDuration = 0.5;
  const startPosition = "top 80%";
  const ease = "power2.out";
  const opacityOffset = 0.3;

  const fadeImageDarknessElements = gsap.utils.toArray(".fade-image-darkness");

  fadeImageDarknessElements.forEach((element) => {
    const computedStyle = window.getComputedStyle(element);
    const targetOpacity = parseFloat(computedStyle.opacity) || 1;
    const startOpacity = Math.min(targetOpacity + opacityOffset, 1.0);
    
    gsap.fromTo(element, {
      opacity: startOpacity,
    }, {
      opacity: targetOpacity,
      duration: animationDuration,
      ease: ease,
      scrollTrigger: {
        trigger: element,
        start: startPosition,
        scrub: true,
        //markers: true,
      }
    });
  });
}
